var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZCoverB2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": " \\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381.2 276.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4f4f4;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": " \\u30EC\\u30A4\\u30E4\\u30FC 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.2,276.1H0V0h381.2v276.1ZM47.9,206.5l81.9,3.4,92.4-6.1,80.2,4.4V56.7l-80.9,7.8-92.2-13.5-81.4,6.5v150-1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZCoverB2);
export default __webpack_public_path__ + "static/media/z_cover_b2.5879fff0cd2b27a56a24ccfff61a666b.svg";
export { ForwardRef as ReactComponent };